// extracted by mini-css-extract-plugin
module.exports = {"delay":"wgjwjEbPgiPUtkza1xQx","delaySuffix":"c5Us7J5xoe6ERHcLMEPV","delayWrapper":"j9KYmGzCceTwV308uJmB","sendToRest":"hTVbDDBGaMOg7xdQDJRi"};